export default "__VITE_ASSET__ZKyg7mko__"